<template>
  <div>
    <Section>
      <template #header class="d-flex align-center">
        <div class="font-weight-bold mr-auto">W9</div>
        <div class="mt-n1 d-flex align-center">
          <div class="grey--text pr-2" style="font-size: 12px;">
            View W-9
          </div>
          <a :href="w9.pdf_url" style="text-decoration: none;">
            <v-btn fab x-small dark color="primary">
              <v-icon small>mdi-paperclip-check</v-icon>
            </v-btn>
          </a>
        </div>   
      </template>

      <div v-if="w9.review_status=='approved'">
        W-9 on file from {{ $formatters.formatDate(w9.signature_date) }}
      </div>

      <div v-if="w9.review_status=='rejected'">
        Oops, we found a problem with your W-9:<br>
        <span class="font-italic red--text" style="font-size: 12px;">{{ w9.review_message }}</span>
      </div>

      <div  v-if="w9.review_status=='unreviewed'">
        We're still reviewing your W-9.  Please be patient, this process may take up to 24 hours...
      </div>

    </Section>

    <div class="d-flex justify-center mt-4">
      <v-btn color="primary" width="60%" :to="{ name: 'account/w9/certification' }">
        Update W9
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { Section } from '@/components/pages'

  export default {
    name: 'AccountWithW9Section',

    props: ['w9'],
    
    components: { Section },
  }
</script>